
var draggable = true;
var zoomControl = false;
var minZoom = 3;

if (is_touch_device()) {
    draggable = false;
    zoomControl = true;
    minZoom = 1;
    if (screen.width > 767 ){
        minZoom = 2;
    }
}

function initialize() {
    geocoder = new google.maps.Geocoder();
    latLngBounds = new google.maps.LatLngBounds();



    var mapOptions = {
        //size: size,
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        panControl: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        scrollwheel: true,
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#133d64"},{"visibility":"on"}]}],
        gestureHandling: 'cooperative'
    };

    // Create a new Google Map
    map = new google.maps.Map(document.getElementById("map"), mapOptions);

    jQuery('.dealers__list-row--body').hide();

    // Add markers
    jQuery.each(mapMarkers, function(index, marker) {
        (function (index) {

            var googleMapsMarker;

            // console.log(dealer + ' = ' + marker.slug);

            if (marker.location && marker.location.lat != '' && marker.location.lng != '' && (dealer == '' || dealer == marker.slug)) {

                // Create marker object
                markersArray[index] = {
                    googleMapsMarker: googleMapsMarker
                }

                // Get the google maps lat/lng from acf lat/lng
                markerLocation = new google.maps.LatLng(marker.location.lat, marker.location.lng);

                // Add the marker location to the lat/lng bounds
                latLngBounds.extend( markerLocation );

                // Create a unique ID from the lat/lng
                var markerId = generateMarkerId(marker.location.lat, marker.location.lng);

                // Create a marker
                markersArray[index].googleMapsMarker = new google.maps.Marker({
                    map : map,
                    position : markerLocation,
                    markerId: markerId,
                    country: marker.country,
                    id: marker.id,
                    //link: marker.link
                });

                // if the marker has a tool tip, add that
                if(marker.toolTip) {

                    var toolTipContent = marker.toolTip;
                    var toolTip = addToolTip(toolTipContent, markerId);

                    google.maps.event.addListener(markersArray[index].googleMapsMarker, 'click', function(event) {

                        showToolTip(toolTip, markersArray[index].googleMapsMarker);

                    });
                }

                jQuery('.dealers__list-row[data-id="'+marker.id+'"]').show();

            }

        })(index);

    });

    centermap = true;

    if (dealer != ''){
        centermap = false;
    }

    mapCenter = latLngBounds.getCenter();
    map.setCenter(mapCenter);
    map.fitBounds(latLngBounds);

    fixMapZoom(centermap);
    moveMapOnHash();
}

function fixMapZoom(init) {
    var listener = google.maps.event.addListener(map, "idle", function() {

        var mapcenter = new google.maps.LatLng(39.497824, 2.812500);

        if (map.getZoom() < minZoom) {
            map.setZoom(minZoom);
            init = true;
        } else if (map.getZoom() > 7) {
            map.setZoom(7);
        }
        if (typeof init !== 'undefined' && init) {
            map.setCenter(mapcenter);
        }
        jQuery('#map').animate({opacity: 1});



        google.maps.event.removeListener(listener);
    });
}

// see also onStoreHash() in main.js
function moveMapOnHash() {
    var stores = jQuery('#stores');
    if(stores.length > 0 && window.location.hash) {
        var store = jQuery(window.location.hash);
        if(store.length > 0) {

            var store_address = jQuery('.store-address a', store);

            // move to the store on the map
            var lat = store_address.data('lat');
            var lng = store_address.data('lng');

            setTimeout(function() {
                panToCoordinates(lat, lng); // delay with a few ms so google maps has time to load (or something)
            }, 100);
        }
    }
}

function getTargetObject(link) {
    return jQuery('[id=' + link +']');
}

function generateMarkerId(lat, lng) {
    return String( parseFloat(lat) + parseFloat(lng) ).replace('.', '');
}

function addToolTip(toolTipContent, markerId) {
    toolTipContent = '<div id="marker-'+markerId+'" class="marker-tooltip">'+toolTipContent+'</div>';

    var infoWindow = new google.maps.InfoWindow({
        content: toolTipContent
    })

    toolTips.push(infoWindow);

    return infoWindow;
}

function openToolTip(toolTip){
    if(!toolTip) {
        var openToolTips = false;

        for(var i = 0; i < toolTips.length; i++) {
            if(isToolTipOpen(toolTips[i])) {
                openToolTips = true;
            }
        }

        return openToolTips;
    } else {
        return isToolTipOpen(toolTip);
    }
}

function isToolTipOpen(toolTip) {
    var toolTipMap = toolTip.getMap();
    return (toolTipMap !== null && typeof toolTipMap !== "undefined");
}

function showToolTip(toolTip, marker) {
    closeToolTip(); // close all tooltips before opening
    toolTip.open(map, marker);
}

function closeToolTip(toolTip) {
    if(!toolTip) {
        for(var i = 0; i < toolTips.length; i++) {
            toolTips[i].close();
        }
    } else {
        toolTip.close();
    }
}

function panToCoordinates(lat, lng) {
    var location = new google.maps.LatLng(lat, lng);
    map.panTo(location);
    map.setZoom(16);
}

function panToAddress(address) {
    geocodeAddress(address, function(location) {
        map.panTo(location);
        map.setZoom(16);
    });
}

var numberOfSearches = 0;

function filterMarkersByCountry(country) {

    jQuery('html, body').animate({
        scrollTop: 0
    }, 500);

    var searchBound = new google.maps.LatLngBounds();
    var foundMarkers = 0;

    jQuery('.dealers__list-row--body').hide();

    jQuery.each(markersArray, function(index, marker) {

        if (typeof marker !== 'undefined') {

            var markerPosition = marker.googleMapsMarker.getPosition();

            if (marker.googleMapsMarker.country == country || country == '') {

                // this is just used if only one marker was returned
                singleMarkerPosition = marker.googleMapsMarker.getPosition();

                searchBound.extend(markerPosition);

                marker.googleMapsMarker.setMap(map);

                // Show store
                var targetObject = getTargetObject(marker.googleMapsMarker.link);
                //showStore(targetObject);

                foundMarkers++;

                jQuery('.dealers__list-row[data-id="'+marker.googleMapsMarker.id+'"]').show();

            } else {

                marker.googleMapsMarker.setMap(null);

            }

        }
    });

    if ( foundMarkers == 1 ) {
        map.setCenter(singleMarkerPosition);
        map.setZoom(15);
    } else {
        map.fitBounds(searchBound);
    }

    fixMapZoom();

}

function filterMarkers(address, radius) {

    jQuery('html, body').animate({
        scrollTop: 0
    }, 500);

    geocodeAddress(address, function(location) {

        jQuery('.dealers__list-row--body').hide();

        // set the center of the map to the address the user searched for

        var foundMarkers = 0;
        var searchBound = new google.maps.LatLngBounds();
        var singleMarkerPosition;
        radius = radius ? radius : 50*1000; // meters

        // Hide all stores
        //hideStore();

        if (window.location.search.indexOf('dev') > -1) {
            new google.maps.Circle({
                center: location,
                radius: radius,
                map: map
            });
        }

        jQuery.each(markersArray, function(index, marker) {

            if (typeof marker !== 'undefined') {

                var markerPosition = marker.googleMapsMarker.getPosition();

                if (google.maps.geometry.spherical.computeDistanceBetween( location, markerPosition ) < radius && address) {

                    // this is just used if only one marker was returned
                    singleMarkerPosition = marker.googleMapsMarker.getPosition();

                    searchBound.extend(markerPosition);

                    marker.googleMapsMarker.setMap(map);

                    // Show store
                    var targetObject = getTargetObject(marker.googleMapsMarker.link);
                    //showStore(targetObject);

                    foundMarkers++;

                    jQuery('.dealers__list-row[data-id="'+marker.googleMapsMarker.id+'"]').show();

                } else {

                    marker.googleMapsMarker.setMap(null);

                }

            }
        });

        // fit the bounds to the found markers
        if(foundMarkers > 1) {
            map.fitBounds(searchBound);
            numberOfSearches = 0;
        }

        // if only one marker, dont use fitbounds if we center it manually we can control the zoom level
        else if(foundMarkers > 0) {
            map.setCenter(singleMarkerPosition);
            map.setZoom(15);
            numberOfSearches = 0;
        }

        // If no markers was found
        else {

            // // fit the bounds to the original markers
            // map.fitBounds(latLngBounds);

            // // Loop thur all markers and show them
            // jQuery.each(markersArray, function(index, marker) {
            //     if (typeof marker !== 'undefined') {
            //         marker.googleMapsMarker.setMap(map);
            //     }

            // });

            // // Show all stores
            // //showStore();

            // // if no marker was found, increase the radius and search again
            // if(numberOfSearches < 3 && address) {
            //     filterMarkers(address, radius + numberOfSearches * 20000); // add 20000 meters for each search
            //     numberOfSearches++;
            //     return;
            // }
            // numberOfSearches = 0;

            initAllMarkers();

            jQuery('.dealers__error').css("opacity", 1);

        }

        fixMapZoom();

    });

}

function geocodeAddress(address, callback) {
    geocoder.geocode({
        address: address,
    }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            callback(results[0].geometry.location);
        } else {
            initAllMarkers();
            return false;
        }
    });
}

function initAllMarkers() {
    jQuery('.dealers__list-row--body').hide();

    initialize();

    jQuery('.dealers__error').css("opacity", 1);
}

function loadScript() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places,geometry&sensor=false&key=AIzaSyBOtCzsisNI3aG9aLCjKje7JwNRzW2t5V4&callback=initialize';
    document.body.appendChild(script);
}


if(typeof google == 'undefined' && document.getElementById("map")) {
    loadScript();
}

(function($){

    $('#map_search').on('submit', function(e){
        e.preventDefault();

        $('#map').animate({opacity: 0}, 300, function(){

            var address = $('#map_search_input').val();
            var country = $('#select_country').val();

            if (address != '') {

                if (country != '') {
                    address = address + ', ' + country;
                }

                filterMarkers(address);
            } else {
                filterMarkersByCountry(country);
            }

        });

        $('.dealers__error').css("opacity", 0);

    });

    $('#select_country').on('change', function(){
        $this = $(this);
        $('#map').animate({opacity: 0}, 300, function(){
            filterMarkersByCountry($this.val());
        });

        $('#map_search_input').val('');
    });

})(jQuery);

function is_touch_device() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}
